// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  POINTS_NUMBER: '[data-fragment="UserCredit.pointsNumber"]',
  WATER_ELEMENT: '[data-fragment="UserCredit.waterElement"]', // on HP
  WATER_ELEMENT_LARGE: '[data-fragment="UserCredit.waterElementLarge"]', // on page
};

export default class UserCreditsTank extends WebComponent {
  constructor(props) {
    super(props);
    this.setWaterLevel = this.setWaterLevel.bind(this);
    this.updateCount = this.updateCount.bind(this);
  }
  didMount() {
    this.userCredit = this.element;
    this.waterEl = this.userCredit.querySelector(fragments.WATER_ELEMENT);
    this.waterElLg = this.userCredit.querySelector(fragments.WATER_ELEMENT_LARGE);
    // getting the amount
    this.pointsNumber = this.userCredit.querySelector(fragments.POINTS_NUMBER);
    // getting the value
    this.pointsAmount = this.pointsNumber.getAttribute('data-points');
    this.maxPoints = 3400;
    // How long you want the animation to take, in ms
    this.animationDuration = 1800;
    // Calculate how long each ‘frame’ should last if
    // we want to update the animation 60 times per second
    this.frameDuration = 1000 / 60;
    // Use that to calculate how many frames we need to complete the animation
    this.totalFrames = Math.round(this.animationDuration / this.frameDuration);
    // An ease-out function that slows the count as it progresses
    this.easeOutQuad = t => t * (2 - t);

    console.log(this.pointsAmount);
    if (this.pointsAmount > 0) {
      // move the water element
      if (this.waterElLg) {
        this.setWaterLevel(this.waterElLg, 170,35);
      }
      if (this.waterEl) {
        this.setWaterLevel(this.waterEl,80,-25);
        this.updateCount();
      }

      if (this.pointsAmount >= 3400) {
        this.userCredit.classList.add('page-user-credits--full');
      }
    }
  }

  setWaterLevel = (el, ySlideRange, offset) => {
    const fill = Math.round(offset - ((ySlideRange / this.maxPoints) * this.pointsAmount));
    el.style.transform = `translateY(${fill}px)`;
    el.style.transform += 'rotate(3deg)';
    el.style.transformOrigin += 'top center';
  };

  updateCount = () => {
    let frame = 0;
    const countTo = parseInt(this.pointsAmount, 10);
    // Start the animation running 60 times per second
    const counter = setInterval(() => {
      frame++;
      // Calculate our progress as a value between 0 and 1
      // Pass that value to our easing function to get our
      // progress on a curve
      const progress = this.easeOutQuad(frame / this.totalFrames);
      // Use the progress value to calculate the current count
      const currentCount = Math.round(countTo * progress);

      // If the current count has changed, update the element
      if (parseInt(this.pointsNumber.innerHTML, 10) !== currentCount) {
        this.pointsNumber.innerHTML = currentCount;
      }

      // If we’ve reached our last frame, stop the animation
      if (frame === this.totalFrames) {
        clearInterval(counter);
      }
    }, this.frameDuration);
  };
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/UserCreditsTank.js